import { useEffect, useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  List,
  ListItem,
  ListItemText,
  CircularProgress,
  Stack,
} from "@mui/material";
import { useTranslation } from "react-i18next"; // 🆕

interface Props {
  open: boolean;
  title: string; // ya viene traducido
  loader: () => Promise<{ id: number; nombre: string }[]>;
  onClose: () => void;
}

export default function RelationDialog({ open, title, loader, onClose }: Props) {
  const { t } = useTranslation<"translation">(); // 🆕
  const [rows, setRows] = useState<{ id: number; nombre: string }[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    loader()
      .then(setRows)
      .finally(() => setLoading(false));
  }, [open, loader]);

  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{title}</DialogTitle>

      <DialogContent dividers>
        {loading ? (
          <Stack alignItems="center" py={4}>
            <CircularProgress aria-label={t("relationDialog.loading") as string} /* opcional */ />
          </Stack>
        ) : (
          <List dense>
            {rows.map((p) => (
              <ListItem key={p.id}>
                <ListItemText primary={p.nombre} />
              </ListItem>
            ))}

            {!rows.length && t("relationDialog.noResults")}
          </List>
        )}
      </DialogContent>
    </Dialog>
  );
}
